import * as devCoordinators from './dev'
import * as subscriberCoordinators from './subscriber'
import * as subscriptionCoordinators from './subscription'

export default Object.freeze({
  ...devCoordinators,
  ...subscriberCoordinators,
  ...subscriptionCoordinators,
})
